(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cjYI7", function(module, exports) {

$parcel$export(module.exports, "filterEvents", function () { return $8f865a3aa08f15c7$export$abcd98354d9fb0f7; });
var $8f865a3aa08f15c7$export$e27bccc8afa33d09 = function(dates) {
    var reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    dates.sort(function(a, b) {
        return new Date(b.dates.end_datetime) - new Date(a.dates.end_datetime);
    });
    if (reverse) dates.reverse();
};
var $8f865a3aa08f15c7$export$82939fba51e2faaf = function(events) {
    events.forEach(function(event) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // if the there are multiple dates in event.date array check if one of the dates is in the future if yes set this start and end timestamp as new date array
        if (event.repeating) try {
            for(var _iterator = event.repeating[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                // if there is a date in the future set this as new date array
                var endDate = new Date(element.end_datetime);
                if (endDate > new Date()) {
                    // set the new date array
                    event.dates = {
                        start_datetime: element.start_datetime,
                        end_datetime: element.end_datetime
                    };
                    // Set the links for the event
                    event.links = element.links;
                    break;
                } else {
                    // Set the last date as the date array
                    event.dates = element;
                    // Set the links for the event
                    event.links = element.links;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return events;
};
var $8f865a3aa08f15c7$export$d85fd0095082f726 = function(events) {
    return events.filter(function(event) {
        return event.dates.start_datetime !== null && event.dates.end_datetime !== null;
    });
};
var $8f865a3aa08f15c7$export$abcd98354d9fb0f7 = function(timeFilter, events) {
    switch(timeFilter){
        case 'upcoming_events':
            // Remove always available events from the list.
            events = $8f865a3aa08f15c7$export$d85fd0095082f726(events);
            // Build the repeating events.
            events = $8f865a3aa08f15c7$export$82939fba51e2faaf(events);
            // Get all upcoming events with the same category filtered by the API.
            events = events.filter(function(event) {
                return new Date(event.dates.end_datetime) > new Date();
            });
            // Sort the most recent events to display first.
            $8f865a3aa08f15c7$export$e27bccc8afa33d09(events, true);
            return events;
        case 'past_events':
            // Remove always available events from the list.
            events = $8f865a3aa08f15c7$export$d85fd0095082f726(events);
            // Build the repeating events.
            events = $8f865a3aa08f15c7$export$82939fba51e2faaf(events);
            // Provides events that took place in the past.
            events = events.filter(function(event) {
                return new Date(event.dates.end_datetime) < new Date();
            });
            // Sorts the past events in descending order, according to when they were held.
            $8f865a3aa08f15c7$export$e27bccc8afa33d09(events);
            // Reduce the amount of past events to a maximum of 20.
            events = events.slice(0, 20);
            return events;
        case 'always_available_events':
            // Reduce the amount of past events to a maximum of 20.
            events = events.slice(0, 20);
            // Return all events.
            return events;
    }
};

});

parcelRegister("3PmoV", function(module, exports) {

$parcel$export(module.exports, "lib", function () { return $2c9782e091f9a46a$export$16c08b91f883959a; });
var $2c9782e091f9a46a$export$16c08b91f883959a = {
    selectors: {
        events: '.events',
        navEvents: '.stage.stage--event .events',
        topNavItems: 'nav.primary li.lvl--1',
        truncate: '.event__description--truncate'
    },
    classes: {
        badge: 'badge',
        badges: 'badges',
        clamp: 'event__description--clamp',
        closed: 'event__description--closed',
        container: 'container',
        ctr: 'events__ctr',
        date: 'event__date',
        description: 'event__description',
        descriptionInner: 'event__description-inner',
        icon: 'event__icon',
        infobox: 'infobox infobox--info-primary',
        location: 'event__location',
        meta: 'event__meta',
        navOpened: 'lvl--open',
        noEvents: 'event__no-events',
        truncate: 'event__description--truncate'
    }
};

});

parcelRegister("10l1s", function(module, exports) {

$parcel$export(module.exports, "setTruncation", function () { return $0bb619276d4ed029$export$e7b6f2bce646ceb2; });
$parcel$export(module.exports, "renderEvents", function () { return $0bb619276d4ed029$export$ff0eb5149c4c561a; });
$parcel$export(module.exports, "renderNoEvents", function () { return $0bb619276d4ed029$export$8f410212441577b3; });

var $56eOf = parcelRequire("56eOf");

var $3PmoV = parcelRequire("3PmoV");
var $0bb619276d4ed029$export$e7b6f2bce646ceb2 = function(ctr) {
    // Add an event listener to the truncated elements.
    var truncatedElms = ctr.querySelectorAll((0, $3PmoV.lib).selectors.truncate);
    truncatedElms.forEach(function(elm) {
        // Get the height of the element when the text is not yet truncated.
        var expandedInnerRect = elm.getBoundingClientRect();
        elm.style.setProperty('--truncate-height-expanded', "".concat(expandedInnerRect.height, "px"));
        // Add a class to the element to indicate that the text is truncated.
        elm.classList.add((0, $3PmoV.lib).classes.closed, (0, $3PmoV.lib).classes.clamp);
        elm.addEventListener('click', function() {
            elm.classList.toggle((0, $3PmoV.lib).classes.closed);
            if (elm.classList.contains((0, $3PmoV.lib).classes.closed)) setTimeout(function() {
                return elm.classList.add((0, $3PmoV.lib).classes.clamp);
            }, 300);
            else elm.classList.remove((0, $3PmoV.lib).classes.clamp);
        });
    });
};
var $0bb619276d4ed029$var$getSchemaAttribute = function(itemprop, isoDatetime) {
    var inline = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var attributes = 'itemprop="'.concat(itemprop, '" content="').concat(isoDatetime, '"');
    if (inline) return attributes;
    else return "<span ".concat(attributes, "></span>");
};
var $0bb619276d4ed029$var$getDates = function(startDateTime, endDateTime, anyTimeLabel) {
    var isAlwaysAvailable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (!startDateTime) startDateTime = new Date().toISOString();
    var formattedString = (0, $56eOf.formatDate)(startDateTime, endDateTime);
    var schemaStartDate = $0bb619276d4ed029$var$getSchemaAttribute('startDate', startDateTime);
    var schemaEndDate = endDateTime ? $0bb619276d4ed029$var$getSchemaAttribute('endDate', endDateTime, false) : '';
    var dateHtml = "<span ".concat(schemaStartDate, ">").concat(formattedString, "</span>").concat(schemaEndDate);
    var alwaysAvailableHtml = "<span ".concat(schemaStartDate, ">").concat(anyTimeLabel, '</span><meta itemprop="eventStatus" content="https://schema.org/EventScheduled">');
    return '<div class="'.concat((0, $3PmoV.lib).classes.date, '"><span class="').concat((0, $3PmoV.lib).classes.icon, '">event</span>').concat(isAlwaysAvailable ? alwaysAvailableHtml : dateHtml, "</div>");
};
var $0bb619276d4ed029$export$88411125f012957a = function(city) {
    return '\n	<div itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">\n		, <span itemprop="addressLocality">'.concat(city, "</span>\n	</div>\n	");
};
var $0bb619276d4ed029$export$7f6e1f46695e51c4 = function(date) {
    var badges = '';
    date.categories.forEach(function(category) {
        badges += '<span class="'.concat((0, $3PmoV.lib).classes.badge, '">').concat(category, "</span>");
    });
    return '<div class="'.concat((0, $3PmoV.lib).classes.badges, '">').concat(badges, "</div>");
};
var $0bb619276d4ed029$var$getLocation = function(location, online) {
    var name = '\n		<span class="'.concat((0, $3PmoV.lib).classes.icon, '">location_on</span>\n		<span itemprop="name">').concat(location.online ? online : location.name, "</span>\n		").concat(!location.online ? $0bb619276d4ed029$export$88411125f012957a(location.city) : '', "\n	");
    return '\n	<div itemprop="location" itemscope itemtype="https://schema.org/Place" class="'.concat((0, $3PmoV.lib).classes.location, '">\n		').concat(location.maps_url !== '' ? '<a href="'.concat(location.maps_url, '" target="_blank" rel="noopener">').concat(name, "</a>") : name, "\n	</div>\n	");
};
var $0bb619276d4ed029$var$createAnchorTag = function(link) {
    return '<a href="'.concat(link.url, '" target="_blank" class="btn btn--').concat(link.indicator, '" itemprop="url">').concat(link.label, "</a>");
};
var $0bb619276d4ed029$var$createNavEventFooter = function(link) {
    return '<footer class="event__footer"><span class="event__link">'.concat(link.label, '</span><span class="event__indicator" aria-hidden="true"></span></footer>');
};
var $0bb619276d4ed029$var$getTheLink = function(links, dates) {
    if (dates.end_datetime === null || dates.start_datetime === null) return links.always.url !== '' ? links.always : null;
    var currentDate = new Date();
    var endDate = new Date(dates.end_datetime);
    if (endDate > currentDate) // Check if the event is still in the future, then return a link that is relevant to the future of the event.
    return links.before.url !== '' ? links.before : null;
    else // Check if the event is in the past, then return a link that is relevant to the past of the event.
    return links.after.url !== '' ? links.after : null;
};
var $0bb619276d4ed029$var$getSchemaImage = function(thumb) {
    if (!thumb) return '';
    // Add schema attribute to the first image tag if it is not already set.
    return thumb.replace(/<img\b(?![^>]*\bitemprop=)/, '<img itemprop="image" ');
};
var $0bb619276d4ed029$export$41c1eb9f1ba569fd = function(date, labels) {
    var title = date.title, thumb = date.thumb, links = date.links, dates = date.dates, excerpt = date.excerpt, location = date.location;
    var link = $0bb619276d4ed029$var$getTheLink(links, dates);
    var linkHtml = link ? $0bb619276d4ed029$var$createAnchorTag(link) : '';
    var isAlwaysAvailable = dates.start_datetime === null && dates.end_datetime === null;
    var schemaImage = $0bb619276d4ed029$var$getSchemaImage(thumb);
    return '\n	<div class="row event" itemscope itemtype="https://schema.org/Event">\n		<div class="col-xl-5">\n	  		<div class="event__thumb">'.concat(schemaImage, '</div>\n		</div>\n		<div class="col-xl-7">\n			').concat($0bb619276d4ed029$export$7f6e1f46695e51c4(date), '\n			<h5 itemprop="name">').concat(title, '</h5>\n			<div class="').concat((0, $3PmoV.lib).classes.meta, '">\n				').concat($0bb619276d4ed029$var$getDates(dates.start_datetime, dates.end_datetime, labels.any_time, isAlwaysAvailable), "\n				").concat(location && (dates.end_datetime !== null || isAlwaysAvailable) ? $0bb619276d4ed029$var$getLocation(location, labels.online) : '', '\n			</div>\n			<div itemprop="description" class="').concat((0, $3PmoV.lib).classes.description, " ").concat(excerpt.length > 70 && (0, $3PmoV.lib).classes.truncate, '">\n				<div class="').concat((0, $3PmoV.lib).classes.descriptionInner, '">').concat(excerpt.text, "</div>\n			</div>\n			").concat(linkHtml, "\n		</div>\n	</div>");
};
var $0bb619276d4ed029$export$66e9f4aec55748ea = function(date) {
    var title = date.title, thumb = date.thumb, links = date.links, dates = date.dates;
    var link = $0bb619276d4ed029$var$getTheLink(links, dates);
    var linkHtml = link ? $0bb619276d4ed029$var$createNavEventFooter(link) : '';
    var isAlwaysAvailable = dates.start_datetime === null && dates.end_datetime === null;
    return "\n	".concat(link ? '<a class="event event--'.concat(link.indicator, '" href="').concat(link.url, '" target="_blank" title="').concat(link.label, '">') : '<div class="event">', "\n			").concat($0bb619276d4ed029$export$7f6e1f46695e51c4(date), '\n			<div class="event__thumb">').concat(thumb, '</div>\n			<div class="').concat((0, $3PmoV.lib).classes.meta, '">\n				').concat(!isAlwaysAvailable ? $0bb619276d4ed029$var$getDates(dates.start_datetime, dates.end_datetime) : '', '\n			</div>\n			<p class="stage-event__title h6">').concat(title, "</p>\n			").concat(linkHtml, "\n	").concat(link ? "</a>" : '</div>');
};
var $0bb619276d4ed029$export$ff0eb5149c4c561a = function(node, labels, events) {
    var isNav = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    // Check if events are already rendered to avoid duplicates.
    if (node.querySelector(".".concat((0, $3PmoV.lib).classes.ctr))) return;
    // Create wrapper for each event section.
    var wrapper = document.createElement('div');
    wrapper.setAttribute('class', (0, $3PmoV.lib).classes.ctr);
    events.forEach(function(date) {
        wrapper.innerHTML += isNav ? $0bb619276d4ed029$export$66e9f4aec55748ea(date) : $0bb619276d4ed029$export$41c1eb9f1ba569fd(date, labels);
    });
    node.append(wrapper);
};
var $0bb619276d4ed029$export$8f410212441577b3 = function(ctr, message) {
    // Check if no-events message is already rendered to avoid duplicates.
    if (ctr.querySelector(".".concat((0, $3PmoV.lib).classes.noEvents))) return;
    var noEvents = document.createElement('div');
    noEvents.setAttribute('class', (0, $3PmoV.lib).classes.noEvents);
    var paragraph = document.createElement('p');
    paragraph.setAttribute('class', (0, $3PmoV.lib).classes.infobox);
    paragraph.innerText = message;
    noEvents.append(paragraph);
    ctr.append(noEvents);
};

});
parcelRegister("56eOf", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $3b690027d85b5d22$export$3ae94a2503e890a1; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");
parcelRequire("9OExv");
var $sBzou = parcelRequire("sBzou");
var $3b690027d85b5d22$export$3ae94a2503e890a1 = function(startDateTime, endDateTime) {
    var _document_querySelector;
    if (!startDateTime) return '';
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var locale = (_document_querySelector = document.querySelector('html')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.lang;
    // Convert UTC ISO 8601 strings to Date objects, then to browser's timezone
    var startDate = (0, $sBzou.toZonedTime)(new Date(startDateTime), timeZone);
    var endDate = endDateTime ? (0, $sBzou.toZonedTime)(new Date(endDateTime), timeZone) : null;
    var formatOptions = {
        weekday: 'short',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timeZone,
        timeZoneName: 'short'
    };
    if (!endDate) {
        // Single date without end time
        var formatter = new Intl.DateTimeFormat(locale, formatOptions);
        return formatter.format(startDate);
    }
    // Date range
    var isSameDay = startDate.toDateString() === endDate.toDateString();
    if (isSameDay) {
        // Same day - show date once, then time range
        var timeRangeFormatter = new Intl.DateTimeFormat(locale, (0, $hApvp._)((0, $kWfK0._)({}, formatOptions), {
            hour: '2-digit',
            minute: '2-digit'
        }));
        return timeRangeFormatter.formatRange(startDate, endDate);
    } else {
        // Different days - show full range
        var rangeFormatter = new Intl.DateTimeFormat(locale, formatOptions);
        return rangeFormatter.formatRange(startDate, endDate);
    }
};

});
parcelRegister("kWfK0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e56f3eac89eefa$export$71511d61b312f219; });

var $6tY97 = parcelRequire("6tY97");
function $f3e56f3eac89eefa$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6tY97._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("6tY97", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b841b45c75a3225$export$71511d61b312f219; });
function $4b841b45c75a3225$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hApvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccd99553ef7f1c61$export$71511d61b312f219; });
function $ccd99553ef7f1c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccd99553ef7f1c61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ccd99553ef7f1c61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("9OExv", function(module, exports) {

$parcel$export(module.exports, "fromZonedTime", function () { return (parcelRequire("4YhDd")).fromZonedTime; });
$parcel$export(module.exports, "toZonedTime", function () { return (parcelRequire("sBzou")).toZonedTime; });

var $dum9G = parcelRequire("dum9G");

var $1VQmd = parcelRequire("1VQmd");

var $4YhDd = parcelRequire("4YhDd");

var $sBzou = parcelRequire("sBzou");

var $gnrt2 = parcelRequire("gnrt2");

var $2ttFm = parcelRequire("2ttFm");

});
parcelRegister("dum9G", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $9d1f433d7e85f276$export$d9468344d3651243; });

var $6p2c1 = parcelRequire("6p2c1");

var $dMJUQ = parcelRequire("dMJUQ");

var $2ttFm = parcelRequire("2ttFm");
var $9d1f433d7e85f276$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $9d1f433d7e85f276$export$d9468344d3651243(date, formatStr) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    formatStr = String(formatStr);
    var matches = formatStr.match($9d1f433d7e85f276$var$tzFormattingTokensRegExp);
    if (matches) {
        var d = (0, $2ttFm.toDate)(options.originalDate || date, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result; // This is a quoted portion, matched only to ensure we don't match inside it
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $dMJUQ.formatters)[token[0]](d, token, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, $6p2c1.format)(date, formatStr, options);
}

});
parcelRegister("6p2c1", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $4a96c752b8b44865$export$d9468344d3651243; });

var $38qp8 = parcelRequire("38qp8");

var $l1hd4 = parcelRequire("l1hd4");

var $kbLdz = parcelRequire("kbLdz");

var $hTzrm = parcelRequire("hTzrm");

var $arqg3 = parcelRequire("arqg3");

var $hIML0 = parcelRequire("hIML0");

var $e3CFm = parcelRequire("e3CFm");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4a96c752b8b44865$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4a96c752b8b44865$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4a96c752b8b44865$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4a96c752b8b44865$var$doubleQuoteRegExp = /''/g;
var $4a96c752b8b44865$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4a96c752b8b44865$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, $l1hd4.getDefaultOptions)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $38qp8.enUS);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    var originalDate = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $hIML0.isValid)(originalDate)) throw new RangeError("Invalid time value");
    var parts = formatStr.match($4a96c752b8b44865$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $hTzrm.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4a96c752b8b44865$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $4a96c752b8b44865$var$cleanEscapedString(substring)
        };
        if ((0, $kbLdz.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($4a96c752b8b44865$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map(function(part) {
        if (!part.isToken) return part.value;
        var token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $arqg3.isProtectedWeekYearToken)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $arqg3.isProtectedDayOfYearToken)(token)) (0, $arqg3.warnOrThrowProtectedError)(token, formatStr, String(date));
        var formatter = (0, $kbLdz.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $4a96c752b8b44865$var$cleanEscapedString(input) {
    var matched = input.match($4a96c752b8b44865$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4a96c752b8b44865$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$4a96c752b8b44865$export$2e2bcd8739ae039 = $4a96c752b8b44865$export$d9468344d3651243;

});
parcelRegister("38qp8", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $248699cb297eb97e$export$137380d9ce54f7f; });

var $laq40 = parcelRequire("laq40");

var $05g11 = parcelRequire("05g11");

var $8K10G = parcelRequire("8K10G");

var $1Hy6l = parcelRequire("1Hy6l");

var $5KBa8 = parcelRequire("5KBa8");
var $248699cb297eb97e$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $laq40.formatDistance),
    formatLong: (0, $05g11.formatLong),
    formatRelative: (0, $8K10G.formatRelative),
    localize: (0, $1Hy6l.localize),
    match: (0, $5KBa8.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$248699cb297eb97e$export$2e2bcd8739ae039 = $248699cb297eb97e$export$137380d9ce54f7f;

});
parcelRegister("laq40", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $f68ebfd6a6586e8d$export$2c14ff85d6318973; });
var $f68ebfd6a6586e8d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $f68ebfd6a6586e8d$export$2c14ff85d6318973 = function(token, count, options) {
    var result;
    var tokenValue = $f68ebfd6a6586e8d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("05g11", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $00fce41b8f116d39$export$cbf60ecb96cbb82f; });

var $kkjiP = parcelRequire("kkjiP");
var $00fce41b8f116d39$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $00fce41b8f116d39$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $00fce41b8f116d39$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $00fce41b8f116d39$export$cbf60ecb96cbb82f = {
    date: (0, $kkjiP.buildFormatLongFn)({
        formats: $00fce41b8f116d39$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $kkjiP.buildFormatLongFn)({
        formats: $00fce41b8f116d39$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $kkjiP.buildFormatLongFn)({
        formats: $00fce41b8f116d39$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("kkjiP", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $ecc4a5fee55a9eb4$export$38e44e97ce4dbb7d; });
function $ecc4a5fee55a9eb4$export$38e44e97ce4dbb7d(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("8K10G", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $65d3672fb2b382ca$export$8fbbfd65594f46a0; });
var $65d3672fb2b382ca$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $65d3672fb2b382ca$export$8fbbfd65594f46a0 = function(token, _date, _baseDate, _options) {
    return $65d3672fb2b382ca$var$formatRelativeLocale[token];
};

});

parcelRegister("1Hy6l", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $13d44267651e2c6b$export$b3bd0bc58e36cd63; });

var $9uinh = parcelRequire("9uinh");
var $13d44267651e2c6b$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $13d44267651e2c6b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $13d44267651e2c6b$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $13d44267651e2c6b$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $13d44267651e2c6b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $13d44267651e2c6b$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $13d44267651e2c6b$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $13d44267651e2c6b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $13d44267651e2c6b$var$ordinalNumber,
    era: (0, $9uinh.buildLocalizeFn)({
        values: $13d44267651e2c6b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $9uinh.buildLocalizeFn)({
        values: $13d44267651e2c6b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9uinh.buildLocalizeFn)({
        values: $13d44267651e2c6b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $9uinh.buildLocalizeFn)({
        values: $13d44267651e2c6b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $9uinh.buildLocalizeFn)({
        values: $13d44267651e2c6b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $13d44267651e2c6b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("9uinh", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $6e852b3098a65175$export$63596d6ee8878b25; });
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $6e852b3098a65175$export$63596d6ee8878b25(args) {
    return function(value, options) {
        var context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var defaultWidth1 = args.defaultWidth;
            var width1 = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width1] || args.values[defaultWidth1];
        }
        var index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("5KBa8", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $42fe1352c96b0b5c$export$4659b591c19bdf3d; });

var $jt10g = parcelRequire("jt10g");

var $bTGBF = parcelRequire("bTGBF");
var $42fe1352c96b0b5c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $42fe1352c96b0b5c$var$parseOrdinalNumberPattern = /\d+/i;
var $42fe1352c96b0b5c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $42fe1352c96b0b5c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $42fe1352c96b0b5c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $42fe1352c96b0b5c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $42fe1352c96b0b5c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $42fe1352c96b0b5c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $42fe1352c96b0b5c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $42fe1352c96b0b5c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $42fe1352c96b0b5c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $42fe1352c96b0b5c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $42fe1352c96b0b5c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $bTGBF.buildMatchPatternFn)({
        matchPattern: $42fe1352c96b0b5c$var$matchOrdinalNumberPattern,
        parsePattern: $42fe1352c96b0b5c$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jt10g.buildMatchFn)({
        matchPatterns: $42fe1352c96b0b5c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $42fe1352c96b0b5c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jt10g.buildMatchFn)({
        matchPatterns: $42fe1352c96b0b5c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $42fe1352c96b0b5c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $jt10g.buildMatchFn)({
        matchPatterns: $42fe1352c96b0b5c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $42fe1352c96b0b5c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jt10g.buildMatchFn)({
        matchPatterns: $42fe1352c96b0b5c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $42fe1352c96b0b5c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jt10g.buildMatchFn)({
        matchPatterns: $42fe1352c96b0b5c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $42fe1352c96b0b5c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("jt10g", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $e2c180fa7329a45d$export$1430a0f35710914d; });
function $e2c180fa7329a45d$export$1430a0f35710914d(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $e2c180fa7329a45d$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $e2c180fa7329a45d$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e2c180fa7329a45d$var$findKey(object, predicate) {
    for(var key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e2c180fa7329a45d$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("bTGBF", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $8a95e1873cbc6190$export$fdaf2fd6d7edde95; });
function $8a95e1873cbc6190$export$fdaf2fd6d7edde95(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("l1hd4", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $f4d70a7b1fd4359c$export$430a3269e24b912e; });
var $f4d70a7b1fd4359c$var$defaultOptions = {};
function $f4d70a7b1fd4359c$export$430a3269e24b912e() {
    return $f4d70a7b1fd4359c$var$defaultOptions;
}
function $f4d70a7b1fd4359c$export$95365be1b0704abc(newOptions) {
    $f4d70a7b1fd4359c$var$defaultOptions = newOptions;
}

});

parcelRegister("kbLdz", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $eb29763755096f39$export$fe98a034cfb96d55; });

var $13Tr7 = parcelRequire("13Tr7");

var $lP99l = parcelRequire("lP99l");

var $5prkl = parcelRequire("5prkl");

var $3RqdC = parcelRequire("3RqdC");

var $8YzXg = parcelRequire("8YzXg");

var $bkVIU = parcelRequire("bkVIU");

var $dRg6B = parcelRequire("dRg6B");
var $eb29763755096f39$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var $eb29763755096f39$export$fe98a034cfb96d55 = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $dRg6B.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $8YzXg.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $bkVIU.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $bkVIU.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $5prkl.getISOWeekYear)(date);
        // Padding
        return (0, $bkVIU.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getFullYear();
        return (0, $bkVIU.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $bkVIU.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $bkVIU.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $dRg6B.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $bkVIU.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $3RqdC.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $bkVIU.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $lP99l.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $bkVIU.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $dRg6B.lightFormatters).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $13Tr7.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $bkVIU.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $bkVIU.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $bkVIU.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $bkVIU.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $eb29763755096f39$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $eb29763755096f39$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $eb29763755096f39$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $eb29763755096f39$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $eb29763755096f39$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $eb29763755096f39$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $dRg6B.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $dRg6B.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bkVIU.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bkVIU.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $dRg6B.lightFormatters).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $dRg6B.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $dRg6B.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $eb29763755096f39$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $eb29763755096f39$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $eb29763755096f39$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $eb29763755096f39$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $eb29763755096f39$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $eb29763755096f39$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $eb29763755096f39$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $eb29763755096f39$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $eb29763755096f39$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $eb29763755096f39$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize) {
        var timestamp = Math.trunc(+date / 1000);
        return (0, $bkVIU.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize) {
        return (0, $bkVIU.addLeadingZeros)(+date, token.length);
    }
};
function $eb29763755096f39$var$formatTimezoneShort(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.trunc(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $bkVIU.addLeadingZeros)(minutes, 2);
}
function $eb29763755096f39$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $bkVIU.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $eb29763755096f39$var$formatTimezone(offset, delimiter);
}
function $eb29763755096f39$var$formatTimezone(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $bkVIU.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    var minutes = (0, $bkVIU.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("13Tr7", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $0c6112c6c9884033$export$d3b42cd8452deec; });

var $iypZR = parcelRequire("iypZR");

var $2miYP = parcelRequire("2miYP");

var $e3CFm = parcelRequire("e3CFm");
function $0c6112c6c9884033$export$d3b42cd8452deec(date, options) {
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = (0, $iypZR.differenceInCalendarDays)(_date, (0, $2miYP.startOfYear)(_date));
    var dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$0c6112c6c9884033$export$2e2bcd8739ae039 = $0c6112c6c9884033$export$d3b42cd8452deec;

});
parcelRegister("iypZR", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $d81f9162009d04e4$export$4a02e9c37dab4871; });

var $6ZpBv = parcelRequire("6ZpBv");

var $lbys7 = parcelRequire("lbys7");

var $afmnY = parcelRequire("afmnY");

var $jnQLG = parcelRequire("jnQLG");

var $ftUQO = parcelRequire("ftUQO");
function $d81f9162009d04e4$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6ZpBv._)((0, $afmnY.normalizeDates)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    var laterStartOfDay = (0, $ftUQO.startOfDay)(laterDate_);
    var earlierStartOfDay = (0, $ftUQO.startOfDay)(earlierDate_);
    var laterTimestamp = +laterStartOfDay - (0, $lbys7.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    var earlierTimestamp = +earlierStartOfDay - (0, $lbys7.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $jnQLG.millisecondsInDay));
}
var // Fallback for modularized imports:
$d81f9162009d04e4$export$2e2bcd8739ae039 = $d81f9162009d04e4$export$4a02e9c37dab4871;

});
parcelRegister("6ZpBv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $516c4cfaa4b34746$export$71511d61b312f219; });

var $ceUCx = parcelRequire("ceUCx");

var $e1lIn = parcelRequire("e1lIn");

var $OKxK3 = parcelRequire("OKxK3");

var $J66Jb = parcelRequire("J66Jb");
function $516c4cfaa4b34746$export$71511d61b312f219(arr, i) {
    return (0, $ceUCx._)(arr) || (0, $e1lIn._)(arr, i) || (0, $J66Jb._)(arr, i) || (0, $OKxK3._)();
}

});
parcelRegister("ceUCx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8e92b680619f4fa4$export$71511d61b312f219; });
function $8e92b680619f4fa4$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("e1lIn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a35200cd1f91429a$export$71511d61b312f219; });
function $a35200cd1f91429a$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("OKxK3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0988c6241722d902$export$71511d61b312f219; });
function $0988c6241722d902$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("lbys7", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $f6c55997d9d6c5c2$export$113002b5eff6e430; });

var $e3CFm = parcelRequire("e3CFm");
function $f6c55997d9d6c5c2$export$113002b5eff6e430(date) {
    var _date = (0, $e3CFm.toDate)(date);
    var utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});
parcelRegister("e3CFm", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $a3bf56cae2749bb4$export$e67a095c620b86fe; });

var $i4Elf = parcelRequire("i4Elf");
function $a3bf56cae2749bb4$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $i4Elf.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$a3bf56cae2749bb4$export$2e2bcd8739ae039 = $a3bf56cae2749bb4$export$e67a095c620b86fe;

});
parcelRegister("i4Elf", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $d287e4c1c762b043$export$ead8a1812b171991; });

var $5djcY = parcelRequire("5djcY");

var $jnQLG = parcelRequire("jnQLG");
function $d287e4c1c762b043$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && (typeof date === "undefined" ? "undefined" : (0, $5djcY._)(date)) === "object" && (0, $jnQLG.constructFromSymbol) in date) return date[0, $jnQLG.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$d287e4c1c762b043$export$2e2bcd8739ae039 = $d287e4c1c762b043$export$ead8a1812b171991;

});
parcelRegister("5djcY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cbd10fe5fe1c504$export$71511d61b312f219; });
function $3cbd10fe5fe1c504$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("jnQLG", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", function () { return $e1c918eec0adf961$export$4fad13613e88edc8; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $e1c918eec0adf961$export$b76b1809a2898f9a; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $e1c918eec0adf961$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $e1c918eec0adf961$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "constructFromSymbol", function () { return $e1c918eec0adf961$export$2a7b97929c48d47d; });
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var $e1c918eec0adf961$export$dfd9b671c89acc8e = 7;
var $e1c918eec0adf961$export$3913210603d8e9ae = 365.2425;
var $e1c918eec0adf961$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e1c918eec0adf961$export$4dec998e48f9c246 = -$e1c918eec0adf961$export$81caae6e1cc7a622;
var $e1c918eec0adf961$export$4fad13613e88edc8 = 604800000;
var $e1c918eec0adf961$export$b76b1809a2898f9a = 86400000;
var $e1c918eec0adf961$export$91246f0b9bd9beff = 60000;
var $e1c918eec0adf961$export$7f72910d6dfd237a = 3600000;
var $e1c918eec0adf961$export$397c2d5776aa9055 = 1000;
var $e1c918eec0adf961$export$3633035e63cee86a = 525600;
var $e1c918eec0adf961$export$ab7da2ccd1075c38 = 43200;
var $e1c918eec0adf961$export$2423174df8cd3cd2 = 1440;
var $e1c918eec0adf961$export$f2f5ae5a8e2d8f9f = 60;
var $e1c918eec0adf961$export$3c58128db900d44e = 3;
var $e1c918eec0adf961$export$80d7e435f744f319 = 12;
var $e1c918eec0adf961$export$4db7641526e3241f = 4;
var $e1c918eec0adf961$export$698aec755e92c695 = 3600;
var $e1c918eec0adf961$export$a77c1a7ebebe2a5a = 60;
var $e1c918eec0adf961$export$815a9362476d2fe3 = $e1c918eec0adf961$export$698aec755e92c695 * 24;
var $e1c918eec0adf961$export$34804a017b31e2fe = $e1c918eec0adf961$export$815a9362476d2fe3 * 7;
var $e1c918eec0adf961$export$7271e9e3478110d1 = $e1c918eec0adf961$export$815a9362476d2fe3 * $e1c918eec0adf961$export$3913210603d8e9ae;
var $e1c918eec0adf961$export$8e6600bbdee7dabb = $e1c918eec0adf961$export$7271e9e3478110d1 / 12;
var $e1c918eec0adf961$export$be1dccf2de902d31 = $e1c918eec0adf961$export$8e6600bbdee7dabb * 3;
var $e1c918eec0adf961$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});




parcelRegister("afmnY", function(module, exports) {

$parcel$export(module.exports, "normalizeDates", function () { return $775cab6f6dc90fca$export$9f53b88e82f64d8d; });

var $5djcY = parcelRequire("5djcY");

var $i4Elf = parcelRequire("i4Elf");
function $775cab6f6dc90fca$export$9f53b88e82f64d8d(context) {
    for(var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        dates[_key - 1] = arguments[_key];
    }
    var normalize = (0, $i4Elf.constructFrom).bind(null, context || dates.find(function(date) {
        return (typeof date === "undefined" ? "undefined" : (0, $5djcY._)(date)) === "object";
    }));
    return dates.map(normalize);
}

});

parcelRegister("ftUQO", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $b455a9dc3e249e8a$export$63fa379ae8a9ba2; });

var $e3CFm = parcelRequire("e3CFm");
function $b455a9dc3e249e8a$export$63fa379ae8a9ba2(date, options) {
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$b455a9dc3e249e8a$export$2e2bcd8739ae039 = $b455a9dc3e249e8a$export$63fa379ae8a9ba2;

});


parcelRegister("2miYP", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $1b7c5bec5c29dc57$export$f91e89d3d0406102; });

var $e3CFm = parcelRequire("e3CFm");
function $1b7c5bec5c29dc57$export$f91e89d3d0406102(date, options) {
    var date_ = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$1b7c5bec5c29dc57$export$2e2bcd8739ae039 = $1b7c5bec5c29dc57$export$f91e89d3d0406102;

});


parcelRegister("lP99l", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $fe35755ac23614ee$export$7cabdc5698b63e2f; });

var $jnQLG = parcelRequire("jnQLG");

var $5seyh = parcelRequire("5seyh");

var $lM11K = parcelRequire("lM11K");

var $e3CFm = parcelRequire("e3CFm");
function $fe35755ac23614ee$export$7cabdc5698b63e2f(date, options) {
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = +(0, $5seyh.startOfISOWeek)(_date) - +(0, $lM11K.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $jnQLG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$fe35755ac23614ee$export$2e2bcd8739ae039 = $fe35755ac23614ee$export$7cabdc5698b63e2f;

});
parcelRegister("5seyh", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $3f8adb0113a8381c$export$6173213f95a4431e; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $fJJi1 = parcelRequire("fJJi1");
function $3f8adb0113a8381c$export$6173213f95a4431e(date, options) {
    return (0, $fJJi1.startOfWeek)(date, (0, $hApvp._)((0, $kWfK0._)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$3f8adb0113a8381c$export$2e2bcd8739ae039 = $3f8adb0113a8381c$export$6173213f95a4431e;

});
parcelRegister("fJJi1", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $b74e3096f467214e$export$42c81a444fbfb5d4; });

var $l1hd4 = parcelRequire("l1hd4");

var $e3CFm = parcelRequire("e3CFm");
function $b74e3096f467214e$export$42c81a444fbfb5d4(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $l1hd4.getDefaultOptions)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$b74e3096f467214e$export$2e2bcd8739ae039 = $b74e3096f467214e$export$42c81a444fbfb5d4;

});


parcelRegister("lM11K", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $fd9ee0a3eb904651$export$236bdfa374eb69a9; });

var $i4Elf = parcelRequire("i4Elf");

var $5prkl = parcelRequire("5prkl");

var $5seyh = parcelRequire("5seyh");
function $fd9ee0a3eb904651$export$236bdfa374eb69a9(date, options) {
    var year = (0, $5prkl.getISOWeekYear)(date, options);
    var fourthOfJanuary = (0, $i4Elf.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $5seyh.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$fd9ee0a3eb904651$export$2e2bcd8739ae039 = $fd9ee0a3eb904651$export$236bdfa374eb69a9;

});
parcelRegister("5prkl", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $3f047c24ed167b5d$export$3dbc52535f6f8fcc; });

var $i4Elf = parcelRequire("i4Elf");

var $5seyh = parcelRequire("5seyh");

var $e3CFm = parcelRequire("e3CFm");
function $3f047c24ed167b5d$export$3dbc52535f6f8fcc(date, options) {
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    var fourthOfJanuaryOfNextYear = (0, $i4Elf.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5seyh.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = (0, $i4Elf.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5seyh.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$3f047c24ed167b5d$export$2e2bcd8739ae039 = $3f047c24ed167b5d$export$3dbc52535f6f8fcc;

});



parcelRegister("3RqdC", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $2cfaa8d100ac39cc$export$efe19b760242b2fc; });

var $jnQLG = parcelRequire("jnQLG");

var $fJJi1 = parcelRequire("fJJi1");

var $2VP9S = parcelRequire("2VP9S");

var $e3CFm = parcelRequire("e3CFm");
function $2cfaa8d100ac39cc$export$efe19b760242b2fc(date, options) {
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = +(0, $fJJi1.startOfWeek)(_date, options) - +(0, $2VP9S.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $jnQLG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$2cfaa8d100ac39cc$export$2e2bcd8739ae039 = $2cfaa8d100ac39cc$export$efe19b760242b2fc;

});
parcelRegister("2VP9S", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $22289698b9ac768d$export$bb7b45bb8e74da0f; });

var $l1hd4 = parcelRequire("l1hd4");

var $i4Elf = parcelRequire("i4Elf");

var $8YzXg = parcelRequire("8YzXg");

var $fJJi1 = parcelRequire("fJJi1");
function $22289698b9ac768d$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $l1hd4.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var year = (0, $8YzXg.getWeekYear)(date, options);
    var firstWeek = (0, $i4Elf.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var _date = (0, $fJJi1.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$22289698b9ac768d$export$2e2bcd8739ae039 = $22289698b9ac768d$export$bb7b45bb8e74da0f;

});
parcelRegister("8YzXg", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $688fd138268dfd8f$export$12d572480ceb6e58; });

var $l1hd4 = parcelRequire("l1hd4");

var $i4Elf = parcelRequire("i4Elf");

var $fJJi1 = parcelRequire("fJJi1");

var $e3CFm = parcelRequire("e3CFm");
function $688fd138268dfd8f$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, $e3CFm.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    var defaultOptions = (0, $l1hd4.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var firstWeekOfNextYear = (0, $i4Elf.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $fJJi1.startOfWeek)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = (0, $i4Elf.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $fJJi1.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$688fd138268dfd8f$export$2e2bcd8739ae039 = $688fd138268dfd8f$export$12d572480ceb6e58;

});



parcelRegister("bkVIU", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $840e56a07c5c96c5$export$c8306e720e213c0f; });
function $840e56a07c5c96c5$export$c8306e720e213c0f(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("dRg6B", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $a16cb7cf9ea0aec0$export$b0d4b338e1516f13; });

var $bkVIU = parcelRequire("bkVIU");
var $a16cb7cf9ea0aec0$export$b0d4b338e1516f13 = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $bkVIU.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $bkVIU.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $bkVIU.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $bkVIU.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $bkVIU.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $bkVIU.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $bkVIU.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $bkVIU.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("hTzrm", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $d0731073a9b2359a$export$70cc8fd02856fd58; });
var $d0731073a9b2359a$var$dateLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $d0731073a9b2359a$var$timeLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $d0731073a9b2359a$var$dateTimeLongFormatter = function(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $d0731073a9b2359a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $d0731073a9b2359a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $d0731073a9b2359a$var$timeLongFormatter(timePattern, formatLong));
};
var $d0731073a9b2359a$export$70cc8fd02856fd58 = {
    p: $d0731073a9b2359a$var$timeLongFormatter,
    P: $d0731073a9b2359a$var$dateTimeLongFormatter
};

});

parcelRegister("arqg3", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $79a0cb474634610f$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $79a0cb474634610f$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $79a0cb474634610f$export$f5f38f90ecaaf879; });
var $79a0cb474634610f$var$dayOfYearTokenRE = /^D+$/;
var $79a0cb474634610f$var$weekYearTokenRE = /^Y+$/;
var $79a0cb474634610f$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $79a0cb474634610f$export$c6cc36aa33304772(token) {
    return $79a0cb474634610f$var$dayOfYearTokenRE.test(token);
}
function $79a0cb474634610f$export$c6b49d6dceb604a1(token) {
    return $79a0cb474634610f$var$weekYearTokenRE.test(token);
}
function $79a0cb474634610f$export$f5f38f90ecaaf879(token, format, input) {
    var _message = $79a0cb474634610f$var$message(token, format, input);
    console.warn(_message);
    if ($79a0cb474634610f$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $79a0cb474634610f$var$message(token, format, input) {
    var subject = token[0] === "Y" ? "years" : "days of the month";
    return "Use `".concat(token.toLowerCase(), "` instead of `").concat(token, "` (in `").concat(format, "`) for formatting ").concat(subject, " to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}

});

parcelRegister("hIML0", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $ce6c5de502dbc6d0$export$1ea939691cdc45b8; });

var $ePMyM = parcelRequire("ePMyM");

var $e3CFm = parcelRequire("e3CFm");
function $ce6c5de502dbc6d0$export$1ea939691cdc45b8(date) {
    return !(!(0, $ePMyM.isDate)(date) && typeof date !== "number" || isNaN(+(0, $e3CFm.toDate)(date)));
}
var // Fallback for modularized imports:
$ce6c5de502dbc6d0$export$2e2bcd8739ae039 = $ce6c5de502dbc6d0$export$1ea939691cdc45b8;

});
parcelRegister("ePMyM", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $accb7f1a3a302c16$export$871608497c498473; });
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
var $5djcY = parcelRequire("5djcY");
function $accb7f1a3a302c16$export$871608497c498473(value) {
    return value instanceof Date || (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$accb7f1a3a302c16$export$2e2bcd8739ae039 = $accb7f1a3a302c16$export$871608497c498473;

});



parcelRegister("dMJUQ", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $a0936000df085a98$export$fe98a034cfb96d55; });

var $9TFp2 = parcelRequire("9TFp2");

var $iv2yx = parcelRequire("iv2yx");
var $a0936000df085a98$var$MILLISECONDS_IN_MINUTE = 60000;
var $a0936000df085a98$export$fe98a034cfb96d55 = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, options) {
        var timezoneOffset = $a0936000df085a98$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $a0936000df085a98$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $a0936000df085a98$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $a0936000df085a98$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, options) {
        var timezoneOffset = $a0936000df085a98$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $a0936000df085a98$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $a0936000df085a98$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $a0936000df085a98$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, options) {
        var timezoneOffset = $a0936000df085a98$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $a0936000df085a98$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $a0936000df085a98$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $9TFp2.tzIntlTimeZoneName)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $9TFp2.tzIntlTimeZoneName)('long', date, options);
        }
    }
};
function $a0936000df085a98$var$getTimeZoneOffset(timeZone, originalDate) {
    var _originalDate_getTimezoneOffset;
    var timeZoneOffset = timeZone ? (0, $iv2yx.tzParseTimezone)(timeZone, originalDate, true) / $a0936000df085a98$var$MILLISECONDS_IN_MINUTE : (_originalDate_getTimezoneOffset = originalDate === null || originalDate === void 0 ? void 0 : originalDate.getTimezoneOffset()) !== null && _originalDate_getTimezoneOffset !== void 0 ? _originalDate_getTimezoneOffset : 0;
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $a0936000df085a98$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $a0936000df085a98$var$formatTimezone(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $a0936000df085a98$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $a0936000df085a98$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimiter + minutes;
}
function $a0936000df085a98$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $a0936000df085a98$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $a0936000df085a98$var$formatTimezone(offset, delimiter);
}
function $a0936000df085a98$var$formatTimezoneShort(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + $a0936000df085a98$var$addLeadingZeros(minutes, 2);
}

});
parcelRegister("9TFp2", function(module, exports) {

$parcel$export(module.exports, "tzIntlTimeZoneName", function () { return $73495ddad6358662$export$90e6cdae187a86ac; });

var $amV4y = parcelRequire("amV4y");
function $73495ddad6358662$export$90e6cdae187a86ac(length, date, options) {
    var defaultOptions = (0, $amV4y.getDefaultOptions)();
    var _options_locale;
    var dtf = $73495ddad6358662$var$getDTF(length, options.timeZone, (_options_locale = options.locale) !== null && _options_locale !== void 0 ? _options_locale : defaultOptions.locale);
    return 'formatToParts' in dtf ? $73495ddad6358662$var$partsTimeZone(dtf, date) : $73495ddad6358662$var$hackyTimeZone(dtf, date);
}
function $73495ddad6358662$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
    return undefined;
}
function $73495ddad6358662$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $73495ddad6358662$var$getDTF(length, timeZone, locale) {
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});
parcelRegister("amV4y", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $78c83adb05f40f08$export$430a3269e24b912e; });

var $l1hd4 = parcelRequire("l1hd4");
function $78c83adb05f40f08$export$430a3269e24b912e() {
    return Object.assign({}, (0, $l1hd4.getDefaultOptions)());
}
var // Fallback for modularized imports:
$78c83adb05f40f08$export$2e2bcd8739ae039 = $78c83adb05f40f08$export$430a3269e24b912e;

});


parcelRegister("iv2yx", function(module, exports) {

$parcel$export(module.exports, "tzParseTimezone", function () { return $d77d1ad12f3171e6$export$57649162eea44a93; });

var $bkKzh = parcelRequire("bkKzh");

var $WcmQ5 = parcelRequire("WcmQ5");
var $d77d1ad12f3171e6$var$MILLISECONDS_IN_HOUR = 3600000;
var $d77d1ad12f3171e6$var$MILLISECONDS_IN_MINUTE = 60000;
var $d77d1ad12f3171e6$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $d77d1ad12f3171e6$export$57649162eea44a93(timezoneString, date, isUtcDate) {
    // Empty string
    if (!timezoneString) return 0;
    // Z
    var token = $d77d1ad12f3171e6$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    var absoluteOffset;
    // ±hh
    token = $d77d1ad12f3171e6$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$d77d1ad12f3171e6$var$validateTimezone(hours)) return NaN;
        return -(hours * $d77d1ad12f3171e6$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $d77d1ad12f3171e6$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$d77d1ad12f3171e6$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $d77d1ad12f3171e6$var$MILLISECONDS_IN_HOUR + minutes * $d77d1ad12f3171e6$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($d77d1ad12f3171e6$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $d77d1ad12f3171e6$var$toUtcDate(date);
        var offset = $d77d1ad12f3171e6$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $d77d1ad12f3171e6$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $d77d1ad12f3171e6$var$toUtcDate(date) {
    return (0, $WcmQ5.newDateUTC)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $d77d1ad12f3171e6$var$calcOffset(date, timezoneString) {
    var tokens = (0, $bkKzh.tzTokenizeDate)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $WcmQ5.newDateUTC)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $d77d1ad12f3171e6$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $d77d1ad12f3171e6$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $d77d1ad12f3171e6$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $d77d1ad12f3171e6$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $d77d1ad12f3171e6$var$validIANATimezoneCache = {};
function $d77d1ad12f3171e6$var$isValidTimezoneIANAString(timeZoneString) {
    if ($d77d1ad12f3171e6$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $d77d1ad12f3171e6$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("bkKzh", function(module, exports) {

$parcel$export(module.exports, "tzTokenizeDate", function () { return $8405af6d2542279c$export$6f7bba78170cdfff; });
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $8405af6d2542279c$export$6f7bba78170cdfff(date, timeZone) {
    var dtf = $8405af6d2542279c$var$getDateTimeFormat(timeZone);
    return 'formatToParts' in dtf ? $8405af6d2542279c$var$partsOffset(dtf, date) : $8405af6d2542279c$var$hackyOffset(dtf, date);
}
var $8405af6d2542279c$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $8405af6d2542279c$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $8405af6d2542279c$var$typeToPos[formatted[i].type];
            if (pos !== undefined) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $8405af6d2542279c$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parseInt(parsed[3], 10),
        parseInt(parsed[1], 10),
        parseInt(parsed[2], 10),
        parseInt(parsed[4], 10),
        parseInt(parsed[5], 10),
        parseInt(parsed[6], 10)
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $8405af6d2542279c$var$dtfCache = {};
// New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
var $8405af6d2542279c$var$testDateFormatted = new Intl.DateTimeFormat('en-US', {
    hourCycle: 'h23',
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
}).format(new Date('2014-06-25T04:00:00.123Z'));
var $8405af6d2542279c$var$hourCycleSupported = $8405af6d2542279c$var$testDateFormatted === '06/25/2014, 00:00:00' || $8405af6d2542279c$var$testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
function $8405af6d2542279c$var$getDateTimeFormat(timeZone) {
    if (!$8405af6d2542279c$var$dtfCache[timeZone]) $8405af6d2542279c$var$dtfCache[timeZone] = $8405af6d2542279c$var$hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
        hourCycle: 'h23',
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
        hour12: false,
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return $8405af6d2542279c$var$dtfCache[timeZone];
}

});

parcelRegister("WcmQ5", function(module, exports) {

$parcel$export(module.exports, "newDateUTC", function () { return $0aef02cc2085f169$export$461165d00818234e; });
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $0aef02cc2085f169$export$461165d00818234e(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2ttFm", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $1cd54d4875ac003a$export$e67a095c620b86fe; });

var $5djcY = parcelRequire("5djcY");

var $hu6wo = parcelRequire("hu6wo");

var $iv2yx = parcelRequire("iv2yx");

var $8nwMK = parcelRequire("8nwMK");
var $1cd54d4875ac003a$var$MILLISECONDS_IN_HOUR = 3600000;
var $1cd54d4875ac003a$var$MILLISECONDS_IN_MINUTE = 60000;
var $1cd54d4875ac003a$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1cd54d4875ac003a$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $8nwMK.tzPattern)
};
function $1cd54d4875ac003a$export$e67a095c620b86fe(argument) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var additionalDigits = options.additionalDigits == null ? $1cd54d4875ac003a$var$DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || (typeof argument === "undefined" ? "undefined" : (0, $5djcY._)(argument)) === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1cd54d4875ac003a$var$splitDateString(argument);
    var _parseYear = $1cd54d4875ac003a$var$parseYear(dateStrings.date, additionalDigits), year = _parseYear.year, restDateString = _parseYear.restDateString;
    var date = $1cd54d4875ac003a$var$parseDate(restDateString, year);
    if (date === null || isNaN(date.getTime())) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1cd54d4875ac003a$var$parseTime(dateStrings.time);
            if (time === null || isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $iv2yx.tzParseTimezone)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, $hu6wo.getTimezoneOffsetInMilliseconds)(new Date(timestamp + time));
            offset = (0, $hu6wo.getTimezoneOffsetInMilliseconds)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1cd54d4875ac003a$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1cd54d4875ac003a$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1cd54d4875ac003a$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1cd54d4875ac003a$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1cd54d4875ac003a$var$parseYear(dateString, additionalDigits) {
    if (dateString) {
        var patternYYY = $1cd54d4875ac003a$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $1cd54d4875ac003a$var$patterns.YYYYY[additionalDigits];
        // YYYY or ±YYYYY
        var token = $1cd54d4875ac003a$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        // YY or ±YYY
        token = $1cd54d4875ac003a$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1cd54d4875ac003a$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var date;
    var month;
    var week;
    // YYYY
    if (!dateString || !dateString.length) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    var token = $1cd54d4875ac003a$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1cd54d4875ac003a$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1cd54d4875ac003a$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1cd54d4875ac003a$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1cd54d4875ac003a$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1cd54d4875ac003a$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1cd54d4875ac003a$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1cd54d4875ac003a$var$validateWeekDate(week)) return new Date(NaN);
        return $1cd54d4875ac003a$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1cd54d4875ac003a$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1cd54d4875ac003a$var$validateWeekDate(week, dayOfWeek)) return new Date(NaN);
        return $1cd54d4875ac003a$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1cd54d4875ac003a$var$parseTime(timeString) {
    var hours;
    var minutes;
    // hh
    var token = $1cd54d4875ac003a$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1cd54d4875ac003a$var$validateTime(hours)) return NaN;
        return hours % 24 * $1cd54d4875ac003a$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1cd54d4875ac003a$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1cd54d4875ac003a$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1cd54d4875ac003a$var$MILLISECONDS_IN_HOUR + minutes * $1cd54d4875ac003a$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1cd54d4875ac003a$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1cd54d4875ac003a$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1cd54d4875ac003a$var$MILLISECONDS_IN_HOUR + minutes * $1cd54d4875ac003a$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1cd54d4875ac003a$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1cd54d4875ac003a$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1cd54d4875ac003a$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1cd54d4875ac003a$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1cd54d4875ac003a$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1cd54d4875ac003a$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1cd54d4875ac003a$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1cd54d4875ac003a$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1cd54d4875ac003a$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1cd54d4875ac003a$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1cd54d4875ac003a$var$validateWeekDate(week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1cd54d4875ac003a$var$validateTime(hours, minutes, seconds) {
    if (hours < 0 || hours >= 25) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("hu6wo", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $0348f0b5d8502684$export$113002b5eff6e430; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $0348f0b5d8502684$export$113002b5eff6e430(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return +date - +utcDate;
}

});

parcelRegister("8nwMK", function(module, exports) {

$parcel$export(module.exports, "tzPattern", function () { return $6199e72fe9c46b9c$export$a859e97a80802e41; });
/** Regex to identify the presence of a time zone specifier in a date string */ var $6199e72fe9c46b9c$export$a859e97a80802e41 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;

});



parcelRegister("1VQmd", function(module, exports) {

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $dum9G = parcelRequire("dum9G");

var $sBzou = parcelRequire("sBzou");
function $1683ba63d37409f4$export$b3ea52468069e196(date, timeZone, formatStr, options) {
    options = (0, $hApvp._)((0, $kWfK0._)({}, options), {
        timeZone: timeZone,
        originalDate: date
    });
    return (0, $dum9G.format)((0, $sBzou.toZonedTime)(date, timeZone, {
        timeZone: options.timeZone
    }), formatStr, options);
}

});
parcelRegister("sBzou", function(module, exports) {

$parcel$export(module.exports, "toZonedTime", function () { return $055fc23bbdbd0090$export$3ee79d090bac6d33; });

var $iv2yx = parcelRequire("iv2yx");

var $2ttFm = parcelRequire("2ttFm");
function $055fc23bbdbd0090$export$3ee79d090bac6d33(date, timeZone, options) {
    date = (0, $2ttFm.toDate)(date, options);
    var offsetMilliseconds = (0, $iv2yx.tzParseTimezone)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("4YhDd", function(module, exports) {

$parcel$export(module.exports, "fromZonedTime", function () { return $39ea714755e451e9$export$7e1e8af4bb294f2b; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $2ttFm = parcelRequire("2ttFm");

var $8nwMK = parcelRequire("8nwMK");

var $iv2yx = parcelRequire("iv2yx");

var $WcmQ5 = parcelRequire("WcmQ5");
function $39ea714755e451e9$export$7e1e8af4bb294f2b(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $8nwMK.tzPattern))) return (0, $2ttFm.toDate)(date, (0, $hApvp._)((0, $kWfK0._)({}, options), {
        timeZone: timeZone
    }));
    date = (0, $2ttFm.toDate)(date, options);
    var utc = (0, $WcmQ5.newDateUTC)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $iv2yx.tzParseTimezone)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

});

parcelRegister("gnrt2", function(module, exports) {

var $iv2yx = parcelRequire("iv2yx");
function $bec419cb315582c0$export$4c9db454e2785fd9(timeZone, date) {
    return -(0, $iv2yx.tzParseTimezone)(timeZone, date);
}

});





var $cjYI7 = parcelRequire("cjYI7");

var $3PmoV = parcelRequire("3PmoV");

var $10l1s = parcelRequire("10l1s");
var $abc1e91866fa6218$var$observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
        var ctr = entry.target;
        if (entry.isIntersecting) fetch(ctr.dataset.restEndpoint).then(function(response) {
            return response.json();
        }).then(function(data) {
            var events = data.events;
            if (ctr.dataset.events !== 'single_event') // If the event is not a single event, we need to filter it to get the events we have specified in the data attribute.
            events = (0, $cjYI7.filterEvents)(ctr.dataset.timeFilter, data.events);
            else if (ctr.dataset.events === 'single_event' && data.events.find(function(event) {
                return event.repeating;
            })) // If the event is repeating, we need to filter it to get the next upcoming date.
            events = (0, $cjYI7.filterEvents)('upcoming_events', data.events);
            if (events.length) (0, $10l1s.renderEvents)(ctr, data.labels, events);
            else (0, $10l1s.renderNoEvents)(ctr, data.labels.no_data);
            $abc1e91866fa6218$var$observer.unobserve(ctr);
            (0, $10l1s.setTruncation)(ctr);
        }).catch(function(error) {
            console.error(error);
            return false;
        });
    });
});
var $abc1e91866fa6218$var$containers = document.querySelectorAll((0, $3PmoV.lib).selectors.events);
$abc1e91866fa6218$var$containers.forEach(function(ctr) {
    // Skip navigation event containers - they are handled by event-nav.js
    if (ctr.closest('.stage.stage--event')) return;
    $abc1e91866fa6218$var$observer.observe(ctr);
});

})();
//# sourceMappingURL=event.min.js.map
